/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'da',
  DatePicker: {
    lang: {
      placeholder: 'Vælg dato',
      rangePlaceholder: ['Startdato', 'Slutdato'],
      locale: 'da_DK',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Ryd',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Vælg tidspunkt',
      dateSelect: 'Vælg dato',
      monthSelect: 'Vælg måned',
      yearSelect: 'Vælg år',
      decadeSelect: 'Vælg årti',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (Page Up)',
      nextMonth: 'Næste måned (Page Down)',
      previousYear: 'Forrige år (Ctrl-venstre pil)',
      nextYear: 'Næste år (Ctrl-højre pil)',
      previousDecade: 'Forrige årti',
      nextDecade: 'Næste årti',
      previousCentury: 'Forrige århundrede',
      nextCentury: 'Næste århundrede'
    },
    timePickerLocale: {
      placeholder: 'Vælg tid'
    }
  },
  TimePicker: {
    placeholder: 'Vælg tid'
  },
  Calendar: {
    lang: {
      placeholder: 'Vælg dato',
      rangePlaceholder: ['Startdato', 'Slutdato'],
      locale: 'da_DK',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Ryd',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Vælg tidspunkt',
      dateSelect: 'Vælg dato',
      monthSelect: 'Vælg måned',
      yearSelect: 'Vælg år',
      decadeSelect: 'Vælg årti',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (Page Up)',
      nextMonth: 'Næste måned (Page Down)',
      previousYear: 'Forrige år (Ctrl-venstre pil)',
      nextYear: 'Næste år (Ctrl-højre pil)',
      previousDecade: 'Forrige årti',
      nextDecade: 'Næste årti',
      previousCentury: 'Forrige århundrede',
      nextCentury: 'Næste århundrede'
    },
    timePickerLocale: {
      placeholder: 'Vælg tid'
    }
  },
  Pagination: {
    items_per_page: '/ side',
    jump_to: 'Gå til',
    jump_to_confirm: 'bekræft',
    page: '',
    prev_page: 'Forrige Side',
    next_page: 'Næste Side',
    prev_5: 'Forrige 5 Sider',
    next_5: 'Næste 5 Sider',
    prev_3: 'Forrige 3 Sider',
    next_3: 'Næste 3 Sider'
  },
  Table: {
    filterTitle: 'Filtermenu',
    filterConfirm: 'OK',
    filterReset: 'Nulstil',
    selectAll: 'Vælg alle',
    selectInvert: 'Inverter valg'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Afbryd',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Afbryd'
  },
  Transfer: {
    searchPlaceholder: 'Søg her',
    itemUnit: 'element',
    itemsUnit: 'elementer'
  },
  Upload: {
    uploading: 'Uploader...',
    removeFile: 'Fjern fil',
    uploadError: 'Fejl ved upload',
    previewFile: 'Forhåndsvisning',
    downloadFile: 'Download fil'
  },
  Empty: {
    description: 'Ingen data'
  }
};
